import { ReactElement } from 'react';
import { useViewProvider } from "../../contexts/view-provider-context/ViewProvider";

export function NoDateSelectedModalContent(): ReactElement {
  const viewProvider = useViewProvider();

  return viewProvider.renderNoDateSelectedModalContent();
}
